export default "__VITE_ASSET__CvftNuNv__"